PREFIX hraApi: <urn:hra-api#>
PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX schema: <http://schema.org/>
PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
PREFIX DSGraphs: <urn:hra-api:TOKEN:ds-info>

SELECT ?status ?message ?checkback ?loadTime ?timestamp ?startTime
FROM DSGraphs:
WHERE {
  DSGraphs: a hraApi:Dataset ;
    hraApi:status ?status ;
    hraApi:message ?message ;
    hraApi:startTime ?startTime ;
    hraApi:updateTime ?updateTime ;

  BIND(IF(?status = 'Ready' || ?status = 'Error', 60 * 60 * 1000, 2000) as ?checkback)
  BIND(STR(?updateTime) as ?timestamp)
}
